// extracted by mini-css-extract-plugin
module.exports = {"summary":"ArticleSummary_summary__i2mAT","base4":"ArticleSummary_base4__UdFz5"};